export class DayScheduledDiscount {
    dayOfTheWeek: number | undefined;
    startTime: Date | undefined;
    endTime: Date | undefined;
    isActive: boolean = false;

    static createDayScheduledDiscount(value: Partial<DayScheduledDiscount>, isActive: boolean) {
        return {
            dayOfTheWeek: value.dayOfTheWeek,
            startTime: value.startTime,
            endTime: value.endTime,
            isActive,
        };
    }

    constructor(init?: Partial<DayScheduledDiscount>) {
        Object.assign(this, init);
    }
}